import ROUTES from '../routes.json';

function appendQueryParam(url, paramName, param) {
  if (url.includes('?')) {
    url += '&';
  } else {
    url += '?';
  }
  url += `${paramName}=${param}`;

  return url;
}

function getActivityPageRoute() {
  const queryParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  const { sponsorshipId, redirectTo, patientId, id } = queryParams;

  let url = `/${ROUTES.activityPage.react}`;

  if (id) {
    url = appendQueryParam(url, 'id', id);
  }

  if (redirectTo) {
    url = appendQueryParam(url, 'redirectTo', redirectTo);
  }

  const patientIdParam = patientId ? patientId : '0';
  url = appendQueryParam(url, 'patientId', patientIdParam);

  if (sponsorshipId) {
    url = appendQueryParam(url, 'sponsorshipId', sponsorshipId);
  }

  return url;
}

export default getActivityPageRoute;
